<div class="container">
  <div class="row mb-1">
    <div class="col-md-12 text-end">
      <button
        (click)="back()"
        class="btn-shadow d-inline-flex align-items-center btn btn-success"
      >
        <i class="fa fa-arrow-circle-left mr-5"></i> Back
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="card-header font-weight-B fs-1r">Vehicle Details</div>

        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button
              class="nav-link active"
              id="nav-generalInFO-tab"
              data-bs-toggle="tab"
              data-bs-target="#generalInFO"
              type="button"
              role="tab"
              aria-controls="generalInFO"
              aria-selected="true"
              (click)="generalInfoVisible()"
            >
              <i class="fa fa-info-circle" aria-hidden="true"></i> General
              Vehicle InFo.
            </button>
            <button
              class="nav-link"
              id="nav-range-tab"
              data-bs-toggle="tab"
              data-bs-target="#range"
              type="button"
              role="tab"
              aria-controls="range"
              aria-selected="true"
              (click)="rangeVisibility()"
            >
              <i class="fa fa-inr" aria-hidden="true"></i> Price Per Range
            </button>
          </div>
        </nav>

        <div class="card-body" *ngIf="isGInfoVisible">
          <div class="row">
            <div class="col-md-3 m-auto vehicle_img">
              <div *ngIf="imageUrl">
                <a href="{{ imageUrl }}" target="_blank">
                  <img src="{{ imageUrl }}" alt=""
                /></a>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-md-1"></div>
            <div class="col-md-2">
              <label for="">Vehicle ID : </label>
              <input
                type="text"
                [ngModel]="vehicleDetail?.vehicleId"
                class="form-control"
                placeholder="Vehicle contact name"
                readonly
              />
            </div>
            <div class="col-md-3">
              <label for=""> ID : </label>
              <input
                type="text"
                [ngModel]="vehicleDetail?._id"
                class="form-control"
                placeholder="Vehicle contact name"
                readonly
              />
            </div>

            <div class="col-md-2">
              <label for="">Vehicle Type : </label>
              <input
                type="text"
                [ngModel]="vehicleDetail?.type"
                class="form-control"
                placeholder="Vehicle type"
                readonly
              />
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2 justify-content-center align-items-center">
            <div class="col-md-1"></div>

            <div class="col-md-2">
              <label for="">Vehicle Capacity : </label>
              <input
                type="text"
                [ngModel]="vehicleDetail?.vehicleCapacity"
                class="form-control"
                placeholder="Vehicle size"
                readonly
              />
            </div>
            <div class="col-md-3">
              <label for="">Vehicle Dimentions : </label>
              <input
                type="text"
                [ngModel]="vehicleDetail?.vehicleSizeDimention"
                class="form-control"
                placeholder="Vehicle size"
                readonly
              />
            </div>
            <div class="col-md-2">
              <label for="">Original Price (/KM): </label>
              <input
                type="text"
                [ngModel]="vehicleDetail?.originalPrice"
                class="form-control"
                placeholder="Original price"
                readonly
              />
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2 justify-content-center align-items-center">
            <div class="col-md-1"></div>

            <div class="col-md-2">
              <label for="">Discount Price/KM : </label>
              <input
                type="text"
                [ngModel]="vehicleDetail?.discountedPrice"
                class="form-control"
                placeholder="Discount price "
                readonly
              />
            </div>
            <div class="col-md-3">
              <label for="">Created On : </label>
              <input
                type="text"
                [ngModel]="
                  vehicleDetail?.createdOn | date : 'dd MMM yyyy hhmm a'
                "
                class="form-control"
                placeholder="Vehicle contact name"
                readonly
              />
            </div>
            <div class="col-md-2">
              <label for="">Rating (Out of 5) : </label>
              <input
                type="number"
                [ngModel]="vehicleDetail?.rating"
                class="form-control"
                placeholder="rating"
                max="5"
                min="1"
                readonly
              />
            </div>

            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2 justify-content-center align-items-center">
            <div class="col-md-1"></div>

            <div class="col-md-2">
              <label for="">Vehicle Size (Length) : </label>
              <div>
                <input
                  type="text"
                  [ngModel]="vehicleDetail?.vehicleLength"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3">
              <label for="">Vehicle Size (Breadth) : </label>
              <div>
                <input
                  type="text"
                  [ngModel]="vehicleDetail?.vehicleBreadth"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-2">
              <label for="">Vehicle Size (Height) : </label>
              <div>
                <input
                  type="text"
                  [ngModel]="vehicleDetail?.vehicleHeight"
                  class="form-control"
                  readonly
                />
              </div>
            </div>

            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2 justify-content-center align-items-center">
            <div class="col-md-1"></div>

            <div class="col-md-2">
              <label for="">Is Deleted : </label>
              <div>
                <input
                  type="text"
                  [ngModel]="vehicleDetail?.isDeleted == 1 ? 'YES' : 'NO'"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3">
              <label for="">Terms & Conditions : </label>
              <div>
                <input
                  type="text"
                  [ngModel]="vehicleDetail?.termsCondition"
                  class="form-control h-10"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-2">
              <label for="">Current Status : </label>
              <div>
                <input
                  type="text"
                  [ngModel]="
                    vehicleDetail?.currentStatus == 1 ? 'Enabled' : 'Disabled'
                  "
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2 justify-content-center align-items-center">
            <div class="col-md-1"></div>

            <div class="col-md-3">
              <label for="">Labour Available : </label>
              <div>
                <input
                  type="text"
                  [ngModel]="
                    vehicleDetail?.labourAvailable == true ? 'YES' : 'NO'
                  "
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2 justify-content-center align-items-center">
            <div class="col-md-1"></div>
            <div class="col-md-2">
              <div>
                <a
                  (click)="onNavigate('IMAGE', vehicleDetail?.images)"
                  class="btn-shadow d-inline-flex align-items-center btn btn-success"
                >
                  <i class="fa fa-eye mr-5"></i> View Image
                </a>
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>

        <!-- range Table -->
        <div class="row justify-content-center" *ngIf="isRangeVisible">
          <div class="col-md-8">
            <h4 class="mt-4">Prices for {{ vehicleDetail.type }}:</h4>
            <table class="table table-bordered table-striped table-hover">
              <thead>
                <tr>
                  <th>Range (KM)</th>
                  <th>Price ( <span class="fa fa-inr"></span> per KM)</th>
                  <th>
                    Discounted Price ( <span class="fa fa-inr"></span> per KM)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let vp of vehicleDetail.vehiclePrice"
                  class="font-weight-B"
                >
                  <td>{{ vp.min }} - {{ vp.max }}</td>
                  <td>{{ vp.price }}</td>
                  <td>{{ vp.discountedPrice }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
